// Helper voor Wikipedia-thumbnails per node/person.
// Probeert een Wikipedia-titel af te leiden uit links[].url van het object;
// roept dan /api/wikipedia/image aan en cachet het resultaat (in-memory).
// Faalt stilletjes — geen foto is geen probleem.

import { getWikipediaImage, searchWikipediaImage } from './api.js'

const memo = new Map()  // key: "kind:id" → Promise<url|null>

// Probeer Wikipedia title af te leiden uit een wiki-link.
// Ondersteund: https://(lang).wikipedia.org/wiki/(Title)
function wikiRefFrom(obj) {
  const links = obj?.links ?? []
  const sources = obj?.sources ?? []
  // Eerst expliciete kind: 'wiki'
  const candidates = [
    ...links.filter(l => l.kind === 'wiki'),
    ...links.filter(l => /wikipedia\.org\/wiki\//i.test(l.url)),
    ...sources.filter(s => /wikipedia\.org\/wiki\//i.test(s.url)),
  ]
  for (const l of candidates) {
    const m = String(l.url).match(/^https?:\/\/([a-z\-]+)\.wikipedia\.org\/wiki\/([^#?]+)/i)
    if (m) {
      const lang = m[1]
      const title = decodeURIComponent(m[2].replace(/_/g, ' '))
      return { title, lang }
    }
  }
  return null
}

function searchFallback(name) {
  if (!name) return Promise.resolve(null)
  return searchWikipediaImage(name)
    .then(res => res?.thumbnail?.source || null)
    .catch(() => null)
}

export function fetchImage(kind, obj, _ctx) {
  if (!obj || !obj.id) return Promise.resolve(null)
  const key = `${kind}:${obj.id}`
  if (memo.has(key)) return memo.get(key)

  if (obj.imageRef?.thumbUrl || obj.imageRef?.url) {
    const url = obj.imageRef.thumbUrl || obj.imageRef.url
    memo.set(key, Promise.resolve(url))
    return memo.get(key)
  }

  const ref = wikiRefFrom(obj)
  const p = ref
    ? getWikipediaImage(ref.title, ref.lang)
        .then(res => res?.thumbnail?.source || null)
        .catch(() => null)
        .then(url => url || searchFallback(obj.name))
    : searchFallback(obj.name)
  memo.set(key, p)
  return p
}
